import { useScrollReveal } from '../../../hooks/useScrollReveal';

const differentials = [
  {
    icon: 'ri-rocket-line',
    title: 'Inteligência estratégica para vender mais',
    description: 'Transformamos presença em resultado. Cada estratégia nasce para gerar performance real e comprovada.',
    color: 'from-amber-200 to-amber-100'
  },
  {
    icon: 'ri-stack-line',
    title: 'Tudo o que sua marca precisa!',
    description: 'Somos uma assessoria full service: criamos, posicionamos e impulsionamos marcas até a conversão e vendas.',
    color: 'from-amber-200 to-amber-300'
  },
  {
    icon: 'ri-flashlight-line',
    title: 'Velocidade com alto padrão',
    description: 'Cumprimos prazos com eficiência, mantendo a qualidade impecável em todas as etapas.',
    color: 'from-amber-100 to-amber-200'
  }
];

export function Differentials() {
  const titleRef = useScrollReveal();
  const card1Ref = useScrollReveal();
  const card2Ref = useScrollReveal();
  const card3Ref = useScrollReveal();

  const cardRefs = [card1Ref, card2Ref, card3Ref];

  return (
    <section className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-6">
        <div ref={titleRef} className="text-center mb-16 scroll-reveal">
          <h2 className="text-5xl font-black text-white mb-4">Diferenciais</h2>
          <p className="text-xl text-gray-400 font-medium">GUEPARDO AGENCIA</p>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-200 to-amber-100 mx-auto mt-4"></div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {differentials.map((item, index) => (
            <div
              key={index}
              ref={cardRefs[index]}
              className="group relative bg-gradient-to-br from-gray-900 to-black rounded-2xl p-8 shadow-2xl hover:shadow-amber-200/20 transition-all duration-500 transform hover:-translate-y-2 cursor-pointer overflow-hidden border border-gray-800 scroll-reveal-scale"
              style={{ transitionDelay: `${index * 0.15}s` }}
            >
              <div className={`absolute top-0 right-0 w-32 h-32 bg-gradient-to-br ${item.color} opacity-10 rounded-full filter blur-2xl group-hover:opacity-20 transition-opacity duration-500`}></div>
              
              <div className={`w-20 h-20 flex items-center justify-center rounded-2xl bg-gradient-to-br ${item.color} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${item.icon} text-4xl text-black`}></i>
              </div>
              
              <h3 className="text-2xl font-bold text-white mb-4">{item.title}</h3>
              <p className="text-gray-400 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}